import React, { type ReactNode } from 'react';

import {
  FEATURE_FORCE_ERROR_STATE,
  useFeatureToggleData,
} from 'src/app/shared/featureToggle';

interface FakeErrorProps {
  children: ReactNode;
}
export const FakeErrorComponent = ({ children }: FakeErrorProps) => {
  const forceErrorState = useFeatureToggleData(FEATURE_FORCE_ERROR_STATE);

  if (forceErrorState) return <>{children}</>;

  return null;
};
